import styled from 'styled-components';

export default styled.div`
	width: var(--px-400);
`;
